'use strict';

/**
 * hide error alert on checkbox mandatory if user clicks on it
 */
function handleMandatoryCheckboxClick() {
    const $this = $(this);
    const errorMessage = $(this).siblings('.notification.with-tooltip').first();
    if (errorMessage.length > 0) {
        errorMessage.removeClass('show-error-message');
    }
    $this.removeClass('is-invalid');
    this.setCustomValidity('');

}

function handleNotificationTooltipDisplayError(){
    $(this).addClass("show-error-message");
}

/**
 * Listener for toggle password icon
 */
function manageCheckboxState() {
    var mandatoryCheckboxes= $('input[type="checkbox"].custom-control-input.mandatory');
    mandatoryCheckboxes.each(function () {
        $(this).on('click', handleMandatoryCheckboxClick);
    });

    $('.notification.with-tooltip').on("display-error", handleNotificationTooltipDisplayError)
}

module.exports = {
    manageCheckboxState
};
